let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("83fxG")).then(() => parcelRequire('7MdHb'));